import { useWindowSize, DeviceSize } from 'hooks/useWindowSize';
import React from 'react';
import { useChatContext } from '../ChatContext';
import { CloseButton } from './styles';

export const ChatClose = (): JSX.Element => {
  const { setIsOpen } = useChatContext();

  const { deviceSize } = useWindowSize();
  const isMobile = deviceSize === DeviceSize.SMALL;
  if (!isMobile) {
    return null;
  }
  return (
    isMobile && (
      <CloseButton onClick={() => setIsOpen(false)} aria-label="Close chat">
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M15.8333 4.16675L4.16663 15.8334"
            stroke="black"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M15.8333 15.8334L4.16663 4.16675"
            stroke="black"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </CloseButton>
    )
  );
};
